import React from "react";
import { styled } from "styled-components";
import { Colors } from "../../ColorConstants";
import { Text } from "../../TextConstants";

const UnitCounter = ({onAdd, onSubtract, count}) => {
  return (
    <ActionContainer>
      <CounterButton onClick={onSubtract}>-</CounterButton>
      <CountValue>{count}</CountValue>
      {/* onClick={() => onAdd(ticket._id)} */}
      <CounterButton onClick={onAdd}>+</CounterButton>
    </ActionContainer>
  );
};

const ActionContainer = styled.div`
  width: 8rem;
  border-radius: 0.25rem;
  border: 1px solid ${Colors.white};
  display: flex;
  flex-direction: row;
`;

const CounterButton = styled.div`
  display: flex;
  color: ${Colors.white};
  justify-content: center;
  align-items: center;
  width: 33.33%;
  background: ${Colors.white};
  font-size: 1.6rem;
  background: ${Colors.aqua};
  border-radius: 0.25rem;
  cursor: pointer;
  padding: 0.2rem 0rem
`;

const CountValue = styled(CounterButton)`
  color: ${Colors.black};
  background: ${Colors.white};
  border-radius: 0;
  cursor: default;
`;

export default UnitCounter;
